import { getters } from './getters.js';
import { actions } from './actions.js';

const state = {
  toastMessages: [],
};

const namespaced = true;

export default {
  state,
  getters,
  actions,
  namespaced,
};
